import { FOCUSABLE_SELECTORS } from './constants';

let previousActiveElement = null;

export function getFocusableElements(container) {
  if (!container) return [];
  const elements = container.querySelectorAll(FOCUSABLE_SELECTORS);
  return Array.from(elements).filter((el) => {
    const style = window.getComputedStyle(el);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      el.offsetParent !== null
    );
  });
}

export function trapFocus(container, event) {
  const focusable = getFocusableElements(container);
  if (focusable.length === 0) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.key === 'Tab') {
    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }
}

export function saveFocus() {
  previousActiveElement = document.activeElement;
}

export function restoreFocus() {
  if (previousActiveElement && previousActiveElement.focus) {
    previousActiveElement.focus();
    previousActiveElement = null;
  }
}

export function focusFirstElement(container) {
  const focusable = getFocusableElements(container);
  if (focusable.length > 0) {
    focusable[0].focus();
  } else if (container) {
    container.setAttribute('tabindex', '-1');
    container.focus();
  }
}

export function createSkipLink(id) {
  const existing = document.getElementById('a11y-skip-link');
  if (existing) return existing;
  const skipLink = document.createElement('a');
  skipLink.id = 'a11y-skip-link';
  skipLink.href = `#${id}`;
  skipLink.className = 'a11y-skip-link';
  skipLink.textContent = 'Skip to main content';
  document.body.insertBefore(skipLink, document.body.firstChild);
  return skipLink;
}
